{
  "rampInfoCard": {
    "labels": {
      "aircraft": "Aeronave",
      "utilization": "Utilización",
      "wind": "Viento",
      "trips": "Viajes",
      "grossDimensions": "Dimensiones brutas",
      "parkableArea": "Área estacionable"
    },
    "tooltips": {
      "aircraftOnRamp": "Aeronaves estacionadas dentro del área de plataforma / Todas las aeronaves mostradas en pantalla.",
      "parkableArea": "Áreas de plataforma delineadas, excluyendo las marcadas como no estacionables (ej. calles de rodaje, obstáculos).",
      "utilization": "Aeronaves estacionadas dentro del contorno de plataforma / Todas las aeronaves en pantalla. (Una aeronave se considera estacionada cuando el tren principal está dentro del contorno general de la plataforma)",
      "grossDimensions": "Largo y ancho básicos del contorno de plataforma",
      "trips": "Viajes activos / Viajes futuros asignados a esta plataforma",
      "wind": {
        "loading": "Condiciones de viento actuales de la estación meteorológica cercana (actualizado cada 5 minutos)",
        "error": "Datos de viento no disponibles de {{stationInfo}}\nÚltima consulta: {{lastUpdated}}\nSe actualiza cada 5 minutos",
        "current": "Condiciones de viento actuales de {{stationInfo}}\nÚltima actualización: {{lastUpdated}}\nSe actualiza cada 5 minutos"
      }
    }
  },
  "namePrefixes": {
    "allTenants": "[Todos los tenants]",
    "allTieDownTenants": "[Todos los inquilinos de amarre]"
  },
  "aircraftFinder": {
    "tooltip": "Buscar aeronave",
    "searchPlaceholder": "Buscar matrícula, modelo, operador",
    "clear": "Borrar"
  },
  "autoPark": {
    "dialog": {
      "title": "Configuración de AutoPark",
      "tabs": {
        "timeRange": "Rango de tiempo",
        "algorithm": "Algoritmo"
      },
      "timeRange": {
        "startTime": "Hora de inicio",
        "endTime": "Hora de fin",
        "duration": "Duración",
        "presets": {
          "oneDay": "1 día",
          "threeDays": "3 días",
          "sevenDays": "7 días"
        },
        "tripSelection": "Viajes en el rango seleccionado: {{selected}} de {{total}} seleccionados"
      },
      "buttons": {
        "cancel": "Cancelar",
        "run": "Ejecutar AutoPark"
      }
    },
    "button": {
      "label": "AutoPark",
      "disabledMessage": "AutoParking no está habilitado para esta plataforma. Habilítalo en la configuración de la plataforma.",
      "tooltip": "AutoPark"
    },
    "decisionLog": {
      "tabs": {
        "spotOccupancy": "Ocupación de posición",
        "listView": "Lista",
        "timelineDev": "Línea de tiempo (Dev)",
        "decisionLog": "Registro de decisiones ({{count}} aeronaves)"
      },
      "statistics": {
        "aircraftPlaced": "Aeronave asignada",
        "successRate": "Tasa de éxito",
        "unplacedAircraft": "Aeronaves sin asignar",
        "partiallyPlaced": "Parcialmente asignado",
        "partialPlacementNote": "Colocado para parte del viaje",
        "averageMoves": "Movim. promedio",
        "executionTime": "Tiempo de ejecución"
      },
      "filters": {
        "all": "Todos ({{count}})",
        "placed": "Colocados ({{count}})",
        "unplaced": "Sin asignar ({{count}})"
      },
      "buttons": {
        "close": "Cerrar",
        "apply": "Aplicar a rampa",
        "applying": "Aplicando..."
      },
      "progress": {
        "title": "Aplicando resultados a la base de datos",
        "message": "Guardando ubicaciones de aeronaves en la base de datos. Por favor espere...",
        "itemName": "ubicación"
      }
    },
    "placementTable": {
      "headers": {
        "status": "Estado",
        "tailNumber": "Matrícula",
        "spots": "Puesto(s)",
        "arrival": "Llegada",
        "departure": "Salida",
        "dwell": "Estadía"
      },
      "summary": {
        "showing": "Mostrando {{filtered}} de {{total}}",
        "placed": "{{count}} colocados",
        "unplaced": "{{count}} sin asignar"
      },
      "filters": {
        "all": "Todo",
        "placed": "Colocado",
        "unplaced": "Sin asignar",
        "searchPlaceholder": "Buscar matrículas..."
      }
    },
    "tripList": {
      "title": "Viajes ({{selected}}/{{total}} seleccionados)",
      "locked": "{{count}} bloqueados",
      "buttons": {
        "all": "Todo",
        "none": "Ning.",
        "lockAll": "Bloquear",
        "unlockAll": "Desbloquear",
        "includeAll": "Todo",
        "excludeAll": "Ning."
      },
      "tooltips": {
        "lockAll": "Bloquear viajes (mantener posiciones)",
        "unlockAll": "Desbloquear vuelos (permitir repark)",
        "includeAll": "Incluir todos en el cálculo",
        "excludeAll": "Excluir todos del cálculo",
        "lock": "Bloquear (mantener posición)",
        "unlock": "Desbloquear (reposicionar)",
        "clickToLock": "Clic para bloquear posición",
        "clickToExclude": "Clic para excluir",
        "clickToInclude": "Clic para incluir",
        "keyboardHint": "↑↓ Navegar • Espacio Ciclar • L Bloquear • Shift+E Excluir todo"
      },
      "filter": {
        "placeholder": "Filtrar por matrícula, marca, modelo..."
      },
      "emptyState": {
        "title": "No hay viajes en el período seleccionado",
        "hint": "Intenta ampliar el rango de fechas usando los botones 3d o 7d de arriba, o verifica que esta plataforma tenga vuelos programados.",
        "addTrips": "Los viajes se pueden añadir desde la vista de Programación."
      },
      "current": "Actual:",
      "invalidDates": "Fechas inválidas",
      "unknownAircraft": "Aeronave desconocida",
      "sizeCategories": {
        "small": {
          "label": "S",
          "tooltip": "Pequeño (<50ft de envergadura)"
        },
        "medium": {
          "label": "M",
          "tooltip": "Mediano (50-80ft de envergadura)"
        },
        "large": {
          "label": "L",
          "tooltip": "Grande (24-37m de envergadura)"
        },
        "extraLarge": {
          "label": "XL",
          "tooltip": "Extra grande (>120 pies de envergadura)"
        }
      },
      "noTrips": "No hay viajes en el rango seleccionado",
      "assign": "Asignar",
      "selectLocation": "Seleccionar ubicación",
      "hangarsSection": "Hangares",
      "rampsSection": "Otras plataformas"
    },
    "assignSuccess": "{{tailNumber}} asignado a {{locationName}}",
    "assignError": "Error al asignar aeronave",
    "capacityBar": {
      "title": "Capacidad spots",
      "utilization": "{{placed}}/{{total}} espacios ({{percent}}% utilizado)",
      "legend": {
        "placed": "Colocados ({{count}})",
        "available": "Disponibles ({{count}})",
        "filtered": "Filtrado ({{count}})",
        "breakdown": {
          "time": "Hora ({{count}})",
          "size": "Tamaño ({{count}})",
          "duration": "Duración ({{count}})",
          "disabled": "Deshabilitados ({{count}})",
          "geometry": "Geometría ({{count}})"
        }
      }
    },
    "parkNextButton": {
      "label": "Sig. parqueo",
      "tooltip": "Sig. parqueo",
      "disabledMessage": "No hay aeronaves sin ubicar disponibles."
    },
    "decisionLogButton": {
      "tooltip": "Ver log de decisiones",
      "disabledTooltip": "Ejecuta AutoPark primero para generar el registro de decisiones"
    },
    "unplacedAircraftDialog": {
      "title": "Aeronaves sin asignar a las {{time}}",
      "subtitle": "{{count}} aeronaves no pudieron ser ubicadas en este momento",
      "noAircraft": "No hay aeronaves sin ubicación en este momento",
      "closeLabel": "Cerrar"
    },
    "timeRangePicker": {
      "durationFormat": {
        "daysHoursMinutes": "{{days}}d {{hours}}h {{minutes}}m",
        "hoursMinutes": "{{hours}}h {{minutes}}m",
        "minutes": "{{minutes}}m"
      }
    },
    "scheduleGanttDialog": {
      "title": "Programación de {{rampName}}",
      "statistics": {
        "aircraftPlaced": "Aeronave posicionada",
        "avgUtilization": "Utilización prom."
      },
      "buttons": {
        "print": "Imprimir",
        "close": "Cerrar",
        "applyToDatabase": "Aplicar a base de datos",
        "applying": "Aplicando..."
      },
      "messages": {
        "unsavedChanges": "Tienes cambios sin guardar. ¿Seguro que deseas cerrar?",
        "pendingChanges": "{{count}} cambio sin guardar"
      },
      "labels": {
        "close": "Cerrar"
      }
    },
    "editableSpotCell": {
      "otherSpots": "Otros espacios"
    },
    "placementTableRowExpanded": {
      "segmentBreakdown": "Desglose de segmento ({{segmentCount}} segmento, {{moveCount}} movimiento)",
      "partialPlacement": "Colocación parcial - {{count}} hueco",
      "placed": "Colocado:",
      "gap": "Gap:",
      "gapLabel": "Intervalo {{index}}:",
      "noAvailableSpots": "Sin espacios disponibles",
      "checkDecisionLog": "Consulta Registro de decisiones para el desglose de filtros"
    },
    "spotSchedulePrintView": {
      "unknownType": "Tipo desconocido",
      "segmentNotes": "Segmento {{current}}/{{total}} ({{moves}} movimientos)",
      "title": "AutoPark Resultados - {{rampName}} - {{dateRange}}",
      "statistics": {
        "aircraftPlaced": "Aeronave posicionada",
        "successRate": "Tasa de éxito",
        "averageMoves": "Movim. promedio"
      },
      "tableHeaders": {
        "tailNumber": "Matrícula",
        "aircraftType": "Tipo de aeronave",
        "arrival": "Llegada",
        "departure": "Salida",
        "duration": "Duración",
        "notes": "Notas"
      },
      "noAircraftScheduled": "(Sin aeronaves programadas)",
      "unplacedAircraft": "Aeronaves sin asignar ({{count}})"
    },
    "placementList": {
      "title": "Asignación de parking",
      "sections": {
        "placed": "Colocado",
        "unplaced": "Sin asignar"
      },
      "headers": {
        "tail": "Cola",
        "spot": "Spot",
        "zone": "Zona",
        "time": "Hora"
      },
      "labels": {
        "allows": "permite",
        "coverage": "cobertura",
        "requested": "req",
        "spotLock": "{{count}} bloqueo spot",
        "move": "{{count}} movimiento",
        "moveAt": "@ {{time}}"
      },
      "tooltips": {
        "sizeVerySmall": "Muy pequeño (ej., Cessna 172)",
        "sizeSmall": "Pequeño (ej., Citation, Phenom 300)",
        "sizeMidsize": "Mediano (ej., Challenger 604)",
        "sizeSuperMidsize": "Super-Mediano (ej., Gulfstream G650)",
        "sizeLarge": "Grande (ej., Global 7500, BBJ)",
        "sizeEnormous": "Enorme (ej., Aerolíneas comerciales)",
        "blocksOne": "Bloquea {{tailNumber}} (sale {{departureTime}})",
        "blocksMultiple": "Bloquea {{count}} aeronaves: {{tailNumbers}}"
      }
    },
    "timelineView": {
      "title": "Línea de tiempo de ocupación de posición (ventana de {{horizonHours}}h)",
      "headers": {
        "zone": "Zona",
        "spot": "Spot",
        "day": "Día {{dayNumber}}"
      },
      "rows": {
        "utilization": "Utilización",
        "placed": "Colocado",
        "unplaced": "Sin asignar"
      },
      "labels": {
        "disabled": "(DESHABILITADO)",
        "stagingArrival": " (A)",
        "stagingDeparture": " (D)"
      },
      "tooltips": {
        "spotDisabled": "Posición deshabilitada (no disponible para el algoritmo)",
        "zoneDisabled": "{{zoneName}} deshabilitada (todos los espacios en la zona no disponibles)",
        "spotAndZoneDisabled": "Posición deshabilitada Y {{zoneName}} deshabilitada",
        "departing": "Salida: {{tailNumbers}}",
        "unplacedAircraft": "{{tailNumbers}} (clic para ver detalles)",
        "blocked": "Bloqueado por {{tailNumber}} en {{spotId}} (sale {{departureTime}})"
      }
    },
    "parkingConfigForm": {
      "time": {
        "min": "min",
        "hour": "hora",
        "hours": "horas",
        "disabled": "0 min (desactivado)"
      },
      "buffer": {
        "title": "Buffer",
        "helpText": "Tiempo adicional (minutos) antes de la llegada y después de la salida para evitar conflictos de espaciado. Ejemplo: La aeronave despega a las 10:00. Con 15 min de margen, el puesto queda disponible a las 10:15.",
        "options": {
          "none": "Sin margen (0)",
          "minutes10": "10 minutos",
          "standard": "Estándar (15)",
          "high": "Alta (20)"
        }
      },
      "plannedMoves": {
        "title": "Movimientos plan.",
        "helpText": "Número máximo de veces que una aeronave puede reubicarse durante su estadía. 0 = sin movimientos (la aeronave permanece en un solo lugar). Ejemplo: Con 1 movimiento permitido, la aeronave podría estacionarse en el Puesto A (8:00-12:00) y luego moverse al Puesto B (12:00-16:00).",
        "options": {
          "none": "Sin divisiones (0)",
          "allow1": "1 movimiento",
          "allow2": "Permitir 2 mov.",
          "allow3": "Permitir 3 mov."
        }
      },
      "allowTrapping": {
        "title": "Permitir captura",
        "helpText": "Cuando está activado, permite colocar aeronaves en posiciones que bloquean las rutas de salida de otras. Cuando está desactivado, solo coloca aeronaves en posiciones que no bloquean a otras (puede dejar aeronaves sin asignar).",
        "label": "Permitir captura"
      },
      "egressWeight": {
        "title": "Peso de salida",
        "helpText": "Controla qué tan fuerte el algoritmo evita ubicaciones que bloquean otras aeronaves. Bajo (1x): penalización mínima. Medio (2x): penalización moderada. Alto (5x): penalización fuerte.",
        "options": {
          "low": "Bajo (1x)",
          "medium": "Mediano (2x)",
          "high": "Alta (5x)"
        }
      },
      "wasteWeight": {
        "title": "Peso de residuos",
        "helpText": "Controla qué tan fuertemente el algoritmo evita asignar aeronaves pequeñas a espacios sobredimensionados. Ayuda a reservar los espacios grandes premium para aeronaves grandes que realmente los necesitan.",
        "options": {
          "disabled": "Deshabilitado (0x)",
          "low": "Bajo (0.5x)",
          "medium": "Mediano (1x)",
          "high": "Alto (2x)",
          "veryHigh": "Muy alta (3x)"
        }
      },
      "structuralWeight": {
        "title": "Peso estructural",
        "helpText": "Controla la penalización para posiciones con topología de bloqueo compleja. Prioriza el uso de posiciones \"limpias\" primero, reservando las complejas como último recurso. Bajo (0.05x): mínimo. Estándar (0.1x): desempate. Alto (0.5x): preferencia fuerte.",
        "options": {
          "disabled": "Deshabilitado (0x)",
          "low": "Bajo (0.05x)",
          "standard": "Estándar (0.1x)",
          "medium": "Medio (0.2x)",
          "high": "Alto (0.5x)"
        }
      },
      "zonePriorityWeight": {
        "title": "Peso de prioridad de zona",
        "helpText": "Controla la preferencia para zonas de alta prioridad. Desactivado (0x): ignorar zonas. Bajo (0.5x): preferencia menor. Estándar (1x): equilibrado. Alto (2x): preferencia fuerte. Muy alto (3x): preferencia máxima.",
        "options": {
          "disabled": "Deshabilitado (0x)",
          "low": "Bajo (0.5x)",
          "standard": "Estándar (1x)",
          "high": "Alto (2x)",
          "veryHigh": "Muy alta (3x)"
        }
      },
      "minDwellWeight": {
        "title": "Peso mín. en plataforma",
        "helpText": "Controla la preferencia para posiciones con requisitos de permanencia mínima. Atrae aeronaves de larga estadía a posiciones remotas/de desborde y repele aeronaves de corta estadía. Desactivado (0x): ignorar permanencia mínima. Bajo (0.5x): preferencia menor. Estándar (1x): equilibrado. Alto (2x): preferencia fuerte. Muy alto (3x): preferencia máxima.",
        "options": {
          "disabled": "Deshabilitado (0x)",
          "low": "Bajo (0.5x)",
          "standard": "Estándar (1x)",
          "high": "Alto (2x)",
          "veryHigh": "Muy alta (3x)"
        }
      },
      "arrivalStagingTime": {
        "title": "Tiempo prep. llegada",
        "helpText": "Duración de operaciones de servicio en llegada: descarga, aduana, combustible, limpieza. Establecer en 0 para desactivar staging de llegada. Requiere zonas de staging configuradas en plataforma. Rango válido: 0-{{max}} minutos."
      },
      "departureStagingTime": {
        "title": "Hora de preparación de salida",
        "helpText": "Duración para preparación de salida: embarque, verificaciones finales, documentación. Establecer en 0 para desactivar el área de preparación de salida. Requiere zonas de preparación configuradas en plataforma. Rango válido: 0-{{max}} minutos."
      },
      "quickTurnThreshold": {
        "title": "Umbral de rotación rápida",
        "helpText": "Tiempo mínimo de permanencia para usar el flujo de staging. Las aeronaves con estadías más cortas omiten el staging y van directamente a posiciones permanentes. Rango válido: {{min}}-{{max}} minutos.",
        "options": {
          "hour1": "1 hora",
          "hours1_5": "1.5 horas",
          "standard": "Estándar (2 horas)",
          "hours3": "3 horas",
          "hours4": "4 horas"
        }
      },
      "sortingStrategy": {
        "title": "Orden de clasificación",
        "helpText": "Controla el orden en que se procesan las aeronaves. Por restricción de tamaño: prioriza aeronaves con menos opciones de posición. Por llegada: procesa por hora de llegada. Híbrido: combina restricción de tamaño + mayor tiempo de permanencia.",
        "options": {
          "arrival": "Orden de llegada",
          "sizeConstrained": "Tamaño restringido primero",
          "longestDwell": "Mayor espera primero",
          "latestDeparture": "Salida más reciente primero",
          "hybrid": "Híbrido (Tamaño + Permanencia)",
          "largestFirst": "Más grande primero"
        }
      }
    },
    "editableTimeCell": {
      "placeholder": "HH:mm"
    },
    "index": {
      "disabledMessages": {
        "autoParkingNotEnabledWithSettings": "AutoParking no está habilitado para esta plataforma. Habilítalo en la configuración de la plataforma.",
        "autoParkingNotEnabled": "AutoParking no está habilitado para esta plataforma.",
        "noUnplacedAircraft": "No hay aeronaves sin ubicar disponibles."
      },
      "buttons": {
        "checkFit": "Ver ajuste"
      }
    },
    "spotOccupancyGantt": {
      "sizeCategories": {
        "verySmall": "Muy pequeño",
        "small": "Pequeño",
        "midsize": "Mediano",
        "superMidsize": "Super-Midsize",
        "large": "Grande",
        "enormous": "Enorme"
      },
      "errors": {
        "spotNotFound": "Posición no hallada"
      },
      "unknownType": "Tipo desconocido",
      "staging": {
        "arrival": "Área de llegadas",
        "departure": "Área de salida"
      },
      "moveCount": "{{count}} movimiento",
      "currentlyViewing": "Viendo:"
    },
    "legend": {
      "title": "Leyenda de colores",
      "auto": "Auto-asignado",
      "manual": "Manual",
      "staging": "Área transitoria",
      "locked": "Bloqueado"
    },
    "planningDialog": {
      "title": "Planificación AutoPark",
      "stats": {
        "placed": "{{placed}}/{{total}} asignados",
        "rate": "{{percent}}% de tasa"
      },
      "buttons": {
        "preview": "Previsual.",
        "running": "Ejecutando...",
        "print": "Imprimir",
        "settings": "Ajustes",
        "applyToRamp": "Aplicar a rampa",
        "applying": "Aplicando...",
        "cancel": "Cancelar"
      },
      "tooltips": {
        "noTripsInRange": "No hay viajes en este período",
        "unlockToPreview": "Desbloquear para previsualizar",
        "showTripList": "Mostrar viajes",
        "hideTripList": "Ocultar viajes",
        "configureAlgorithm": "Configura cómo AutoPark posiciona las aeronaves. Los presets ofrecen configuraciones rápidas, o ajusta los pesos individuales a continuación."
      },
      "presets": {
        "label": "Predef.",
        "balanced": {
          "label": "Equilibrado (Por defecto)",
          "description": "Buen equilibrio entre eficiencia y estabilidad"
        },
        "conservative": {
          "label": "Conservador",
          "description": "Minimizar movimientos, priorizar estabilidad"
        },
        "aggressive": {
          "label": "Agresivo",
          "description": "Maximizar eficiencia del espacio"
        },
        "custom": {
          "label": "Personal",
          "description": "Configuración manual"
        }
      },
      "workflow": {
        "title": "Cómo funciona AutoPark",
        "step1": "<strong>Selecciona viajes</strong> en el panel izquierdo para incluir en la planificación",
        "step2": "<strong>Bloquea los viajes</strong> que quieras mantener en su posición actual",
        "step3": "<strong>Haz clic en \"Ejecutar vista previa\"</strong> para ver las sugerencias del algoritmo",
        "step4": "<strong>Revisar cambios</strong>, luego Aplicar a Plataforma",
        "footer": "Viajes bloqueados no se mueven. Los desbloqueados pueden reubicarse según tamaño, hora de llegada y prioridad de zona."
      },
      "algorithmSettings": "Configuración de algoritmo"
    },
    "impactSummary": {
      "locked": "bloqueado",
      "moving": "moviendo",
      "new": "new",
      "conflicts": "conflictos",
      "tooltips": {
        "locked": "{{count}} viajes permanecerán en sus posiciones actuales",
        "moving": "{{count}} viajes se moverán a nuevos espacios",
        "new": "{{count}} viajes sin asignar recibirán lugares",
        "conflicts": "{{count}} viajes no pudieron ser asignados",
        "utilization": "Cambio en utilización de posición: {{before}}% → {{after}}%"
      },
      "details": {
        "moves": "Movimientos ({{count}}):",
        "conflicts": "Conflictos ({{count}}):"
      },
      "unknown": "Desconoc."
    }
  },
  "ramp": {
    "referenceModeAlert": "Esta es tu plataforma de referencia de Tie Town Tenant. Solo muestra tus inquilinos de amarre y es distinta de tu plataforma activa actual."
  },
  "rampPrintLayout": {
    "aircraft": "Aeronave",
    "footer": {
      "automaticallyOptimizedBy": "Optimizado automáticamente por",
      "contactInfo": "Contáctenos en www.airplx.com o peter@airplx.com."
    }
  },
  "temporalTest": {
    "index": {
      "title": "Prueba estac. temporal",
      "testScenario": "Escenario de prueba",
      "buttons": {
        "running": "Ejecutando...",
        "runPlanner": "Planificador"
      },
      "stats": {
        "planningStatistics": "Estadísticas planificación",
        "totalAircraft": "Total de aeronaves:",
        "placed": "Colocado:",
        "unplaced": "Sin asignar:",
        "plannedMoves": "Mov. planificados:",
        "traps": "Trampas:",
        "aircraftBlocking": "aeronave bloqueando",
        "others": "otros",
        "none": "Ninguno ✓",
        "expected": "Esperado:",
        "placedSlash": "colocado /",
        "unplacedSuffix": "sin asignar",
        "matchCheck": " ✓",
        "mismatch": " (no coincide)"
      },
      "instructions": "Selecciona un escenario y haz clic en \"Ejecutar Planificador\" para generar asignaciones de estacionamiento",
      "decisionLog": "Registro de decisiones ({{count}} eventos)",
      "parameterGuide": {
        "title": "Guía de parámetros",
        "buffer": {
          "title": "Buffer",
          "description": "Tiempo adicional (minutos) antes de la llegada y después de la salida para evitar conflictos por espaciado reducido.",
          "example": "Ejemplo: La aeronave A despega a las 10:00. Con 15 min de margen, el puesto queda disponible a las 10:15, evitando rotaciones apresuradas."
        },
        "plannedMoves": {
          "title": "Movimientos plan.",
          "description": "Número máximo de veces que una aeronave puede ser reubicada durante su estadía. 0 = sin movimientos (la aeronave permanece en un solo lugar).",
          "example": "Ejemplo: La aeronave llega a las 8:00 y sale a las 16:00. Con 1 movimiento permitido, podría estacionarse en el Puesto A (8:00-12:00) y luego moverse al Puesto B (12:00-16:00) si no hay un solo puesto disponible para las 8 horas completas."
        },
        "allowTrapping": {
          "title": "Permitir captura",
          "description": "Cuando está activado, permite colocar aeronaves en posiciones que bloquean las rutas de salida de otras. Cuando está desactivado, solo coloca aeronaves en posiciones que no bloquean a otras (puede dejar aeronaves sin asignar).",
          "example": "Ejemplo: Una fila tiene posiciones A (adelante) y B (atrás). La aeronave en B sale a las 14:00, la aeronave en A sale a las 16:00. Sin permitir bloqueo, B no puede usarse (quedaría bloqueada). Permitiendo bloqueo, ambas posiciones pueden usarse."
        },
        "egressWeight": {
          "title": "Peso de salida",
          "description": "Controla qué tan fuertemente el algoritmo evita ubicaciones que bloquean otras aeronaves.",
          "levels": {
            "low": "• Bajo (1x): Penalización mínima - prefiere espacios sin restricciones pero acepta bloqueos cuando es necesario",
            "medium": "• Medio (2x): Penalización moderada - trabaja más para evitar conflictos, puede dejar aeronaves sin ubicar",
            "high": "• Alta (5x): Penalización fuerte - prioriza significativamente las ubicaciones sin trampas sobre la cantidad de ubicaciones"
          },
          "example": "Ejemplo: Posición A bloquea 2 aeronaves (puntuación = 2 × peso), Posición B bloquea 0 (puntuación = 0). Con peso Alto (5x), Posición A obtiene 10 vs Posición B obtiene 0, haciendo que Posición B sea fuertemente preferida."
        },
        "wasteWeight": {
          "title": "Peso de residuos",
          "description": "Controla qué tan fuertemente el algoritmo evita asignar aeronaves pequeñas a espacios sobredimensionados. Ayuda a reservar los espacios grandes premium para aeronaves grandes que realmente los necesitan.",
          "levels": {
            "disabled": "• Deshabilitado (0x): Sin penalización - ignora discrepancia de tamaño de posición, el algoritmo asigna libremente",
            "low": "• Bajo (0.5x): Ajuste suave - ligera preferencia por espacios del tamaño adecuado",
            "medium": "• Media (1x): Penalización equilibrada - comparable al peso de salida",
            "high": "• Alta (2x): Preferencia fuerte - evita activamente posiciones sobredimensionadas",
            "veryHigh": "• Muy alta (3x): Penalización extrema - reserva agresivamente espacios grandes para aeronaves grandes"
          },
          "example": "Ejemplo: Citation (pequeño) en un puesto con capacidad para grandes tiene desperdicio=3. Con peso Medio (1x), penalización por desperdicio=3. Con peso Alto (2x), penalización=6. Si un puesto solo-pequeño adecuado tiene puntuación=0 y el puesto grande tiene penalización de salida=2, entonces: Medio da puntuaciones 0 vs 5 (prefiere pequeño), Alto da puntuaciones 0 vs 8 (prefiere fuertemente pequeño)."
        },
        "sortingStrategy": {
          "title": "Ordenamiento",
          "description": "Controla el orden en que las aeronaves son procesadas por el algoritmo de asignación greedy. Diferentes ordenamientos pueden afectar significativamente las tasas de asignación.",
          "strategies": {
            "arrivalOrder": "• Orden de llegada: Procesar por hora de llegada (primero los más tempranos). Realista pero puede desperdiciar espacios flexibles.",
            "sizeConstrained": "• Primero por restricción de tamaño: Coloca primero las aeronaves con menos espacios compatibles. Evita desperdiciar espacios flexibles en aeronaves flexibles.",
            "longestDwell": "• Permanencia más larga primero: Coloca primero las aeronaves con mayor tiempo de estadía. Asegura prioridad a las permanencias prolongadas.",
            "latestDeparture": "• Última salida primero: Coloca primero las aeronaves con salida más tardía. Optimiza el estacionamiento nocturno.",
            "hybrid": "• Híbrido: Combina restricción por tamaño y mayor tiempo de espera (más restringido + mayor espera primero)."
          },
          "example": "Ejemplo: 2 espacios (A=Solo pequeños, B=Flexible). Llega primero un avión pequeño, el algoritmo greedy lo coloca en B (desperdicia flexibilidad). Llega un avión grande, rechazado (solo B funciona, ahora ocupado). Con ordenamiento por restricción de tamaño: El grande se coloca primero en B, el pequeño toma A → ¡ambos colocados!"
        },
        "sizeCategories": {
          "title": "Categorías de tamaño",
          "description": "Los aviones se asignan a categorías de tamaño según su envergadura. Los puestos tienen políticas que restringen qué tamaños de avión aceptan, permitiendo reglas de estacionamiento flexibles.",
          "sizes": {
            "verySmall": "• VS (Very Small): ~35-40ft de envergadura (Cessna 172, Piper PA-28, Cirrus SR22)",
            "small": "• S (Pequeño): ~50-60ft de envergadura (Citations, Phenom 300, King Air 350, Learjet 45)",
            "midsize": "• M (Mediano): ~60-70ft de envergadura (Challenger 604/605, Falcon 900, Gulfstream G280)",
            "superMidsize": "• SM (Super-Midsize): ~75-100ft de envergadura (Falcon 7X, Gulfstream G500/G650)",
            "large": "• L (Grande): ~100-120 pies de envergadura (Global 6000/7500, Gulfstream G700, BBJ)"
          },
          "spotPolicies": "Políticas de posiciones: Cada posición tiene una lista de tamaños permitidos que determina qué aeronaves pueden estacionarse allí.",
          "policies": {
            "universal": "• Universal: [VS, S, M, SM, L] - acepta todos los tamaños de aeronave",
            "largeOnly": "• Solo grandes: [L] - reserva el espacio para aeronaves grandes (evita desperdicio)",
            "commonJets": "• Jets comunes: [S, M] - bloquea aeronaves muy pequeñas y grandes"
          },
          "example": "Ejemplo: el puesto A01 permite [S, M] (solo aeronaves pequeñas y medianas). Una aeronave grande (L) llega pero no puede usar A01 debido a restricciones de tamaño. Debe encontrar un puesto que permita aeronaves grandes."
        }
      }
    },
    "decisionLogDisplay": {
      "noEntries": "Sin entradas en el registro de decisiones",
      "lane": "Carril",
      "timeConflict": "❌ Conflicto de tiempo",
      "blocks": "📍 Bloquea",
      "deps": "✓ Deps:",
      "aircraftSize": "Tamaño de Aeronave",
      "breakdown": "Desglose",
      "collision": "Colisión",
      "depsWarning": "Advertencia Deps",
      "durationAnalysis": {
        "exceedsBy": "Excede Por",
        "minutes": "Minutos",
        "requiredDwell": "Permanencia Requerida",
        "spotLimit": "Límite de Lugar",
        "title": "Análisis de Duración"
      },
      "of": "De",
      "otherOptions": "Otras Opciones",
      "primary": "Principal",
      "primaryBlocker": "Bloqueador Principal",
      "quickFix": "Solución Rápida",
      "rejectionReasons": {
        "durationExceeded": "Duración Excedida",
        "geometryCollision": "Colisión Geométrica",
        "sizeIncompatible": "Tamaño Incompatible",
        "spotsDisabled": "Lugares Deshabilitados",
        "timeConflicts": "Conflictos de Tiempo",
        "unknown": "Desconocido"
      },
      "sizeAnalysis": {
        "aircraft": "Aeronave",
        "length": "Longitud",
        "none": "Ninguno",
        "spotsAllowing": "Lugares que Permiten",
        "spotsBySize": "Lugares por Tamaño",
        "title": "Análisis de Tamaño",
        "wingspan": "Envergadura"
      },
      "spots": "Lugares",
      "timeAnalysis": {
        "aircraftDwell": "Permanencia de Aeronave",
        "conflictWindow": "Ventana de Conflicto",
        "minutes": "Minutos",
        "minutesSuffix": "Sufijo Minutos",
        "peakCongestion": "Congestión Máxima",
        "spotsOccupied": "Lugares Ocupados",
        "spotsOccupiedSuffix": "Sufijo Lugares Ocupados",
        "timeConflicts": "Conflictos de Tiempo",
        "title": "Análisis de Tiempo"
      }
    }
  },
  "lastMinuteInsertion": {
    "dialog": {
      "aircraftStatus": {
        "spotUnknown": "Lugar Desconocido",
        "unknown": "Desconoc.",
        "unplaced": "Sin asignar"
      },
      "buttons": {
        "checkAvailability": "Consultar disponibilidad",
        "close": "Cerrar"
      },
      "errors": {
        "invalidTimeRange": "Error: Rango de tiempo no válido"
      },
      "labels": {
        "aircraft": "Aeronave",
        "arrivalTime": "Hora de llegada",
        "departureTime": "Hora de salida",
        "maxAircraftMoves": "Máx. movimientos aeronaves"
      },
      "placeholders": {
        "selectAircraft": "Seleccionar aeronave"
      },
      "results": {
        "failed": {
          "suggestions": "Sugerencias",
          "title": "Fallido"
        },
        "localRepair": {
          "message": "Reparación local",
          "title": "Reparación local"
        },
        "zeroDisruption": {
          "message": "Cero interrupciones",
          "title": "Cero interrupciones"
        }
      },
      "slider": {
        "marks": {
          "max": "Máx.",
          "two": "Dos",
          "zero": "Cero"
        }
      },
      "title": "Diálogo"
    }
  }
}
